import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SpecraBadge, SpecraButton } from '@mono/ui-components';
import { Testids } from '@mono/ui-selectors';
import { X } from 'lucide-react';
import { useState } from 'react';
import { GovernmentOrgPicker } from '../../Delivery/_shared/components/GovernmentOrgPicker';
import { formatGovernmentOrgLabel, useGovernmentOrgCatalog } from '../../Delivery/Programs/referenceDataHooks';
/** Label for a stored organization value: the registry org's name, or the raw text when it is
 * an older free-text entry that matches no registry org. */ export function useOrganizationLabel() {
    const catalog = useGovernmentOrgCatalog();
    return (value)=>{
        const org = catalog.byId.get(value);
        return org ? {
            label: formatGovernmentOrgLabel(org),
            matched: true
        } : {
            label: value,
            matched: false
        };
    };
}
/**
 * Landscape organizations, picked from the registry (no typed ids). Older Landscapes stored
 * free text; those values stay visible as "unmatched" chips and can be removed.
 */ export function LandscapeOrganizationsField({ value, onChange, disabled }) {
    const labelOf = useOrganizationLabel();
    // The picker is an "add one" control: it resets after each pick.
    const [pickerKey, setPickerKey] = useState(0);
    return /*#__PURE__*/ _jsxs("div", {
        className: "space-y-2",
        "data-testid": Testids.landscapes.organizationsInput,
        children: [
            value.length > 0 && /*#__PURE__*/ _jsx("ul", {
                className: "flex flex-wrap gap-1.5",
                children: value.map((v)=>{
                    const { label, matched } = labelOf(v);
                    return /*#__PURE__*/ _jsxs("li", {
                        className: "inline-flex items-center gap-1 rounded-md border px-2 py-0.5 text-sm",
                        children: [
                            /*#__PURE__*/ _jsx("span", {
                                children: label
                            }),
                            !matched && /*#__PURE__*/ _jsx(SpecraBadge, {
                                variant: "warning",
                                children: "unmatched"
                            }),
                            /*#__PURE__*/ _jsx(SpecraButton, {
                                type: "button",
                                size: "xs",
                                variant: "ghost",
                                "aria-label": `Remove ${label}`,
                                disabled: disabled,
                                onClick: ()=>onChange(value.filter((x)=>x !== v)),
                                children: /*#__PURE__*/ _jsx(X, {
                                    className: "h-3 w-3"
                                })
                            })
                        ]
                    }, v);
                })
            }),
            /*#__PURE__*/ _jsx(GovernmentOrgPicker, {
                id: "landscape-organization-picker",
                label: "Add an organization",
                value: "",
                onChange: (orgId)=>{
                    if (orgId && !value.includes(orgId)) onChange([
                        ...value,
                        orgId
                    ]);
                    setPickerKey((k)=>k + 1);
                },
                testid: Testids.landscapes.organizationPicker
            }, pickerKey)
        ]
    });
}
